// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b25addc","239":"09d6ef21","453":"40237f8d","455":"1e00d384"}[chunkId] + ".chunk.js";
};